import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import { ToastContainer } from 'react-toastify';
import './../../assets/css/loader.css'
import 'react-toastify/dist/ReactToastify.css';

function MyVerticallyCenteredModal(props) {

  const { IR_STATUS } = props
  const [data, setData] = useState({
    startDate: { name: "startDate", value: "", error: "", isRequired: true },
    from: { name: "from", value: "", error: "", isRequired: true },
    to: { name: "to", value: "", error: "", isRequired: true },
    when: { name: "when", value: "", error: "", isRequired: true },
    topic: { name: "topic", value: IR_STATUS, error: "", isRequired: true },
    error: false

  })


  const onChangeHandler = (e) => {

    let value = e.target.value;
    let name = e.target.name;

    if (data.error == true) {
      setData({ ...data, [name]: { name: name, value: value, error: "", isRequired: true }, error: false })
    } else {
      setData({ ...data, [name]: { name: name, value: value, error: "", isRequired: true } })

    }

    console.log("data", data);
  }


  const onSubmit = async () => {
    // const { startDate, endDate, duration, from, to, when, topic } = data



    let allData = {
      startDate: data.startDate.value,
      from: data.from.value,
      to: data.to.value,
      when: data.when.value,
      topic: data.topic.value,
    }
    setData({ ...data, error: true })
    if (data.startDate.value != "" && data.from.value != "" && data.topic.value != "" && data.when.value != "") {
      document.getElementById('createButton').disabled = true
      document.getElementById('createButton').innerText = ""
      document.getElementById('loading').innerHTML = '<div class="centerDiv" ><div class="loader"></div></div>'


      await props.createMeeting(allData)
    }

  }
  debugger
  return (

    <Modal
      {...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered >


      <h1>   </h1>

      <Modal.Title id="contained-modal-title-vcenter" className="text-center text-capitalize" style={{ margin: "10px" }}  >
        CREATE MEETING - {props.IR_STATUS} <hr />
      </Modal.Title>

      <Form>
        <Form.Group className="mb-3" controlId="formBasicEmail">
          <Container>

            <Row>
              <Col>
                <Form.Label>Start Date </Form.Label>
                <Form.Control type="date" placeholder="" name="startDate" onChange={onChangeHandler} />
              </Col>
            </Row>

            {
              data.error && data.startDate.value.trim().length == 0 ?
                <span className="text-danger"> start date is required </span> : ""
            }

          </Container>
        </Form.Group>
        <Form.Group className="mb-3" controlId="formBasicPassword">
          <Container>

            <Row>
              <Col>
                <Form.Label> When </Form.Label>
                <Form.Control type="time" placeholder="" name="when" onChange={onChangeHandler} />
              </Col>


            </Row>

            {
              data.error && data.when.value.trim().length == 0 ?
                <span className="text-danger"> Time is required  </span> : ""
            }
            <br></br>


            <Form.Label> Duration  </Form.Label>

            <Row>
              <Col>
                <Form.Control type="number" placeholder="HR" name="from" max={24} min={0} onChange={onChangeHandler} />
              </Col>

              <Col>
                <Form.Control type="number" placeholder="MIN" name="to" max={60} min={0} onChange={onChangeHandler} />
              </Col>
            </Row>

            {
              data.error && data.from.value.trim().length == 0 ?
                <span className="text-danger"> Duration is required  </span> : ""
            }

            <Row>
              <Col className="my-3" >
                <Form.Label>Topic </Form.Label>
                <Form.Control type="text" placeholder={props.IR_STATUS} name="topic" value={data.topic.value} onChange={onChangeHandler} />
              </Col>
            </Row>

            {
              data.error && data.topic.value.trim().length == 0 ?
                <span className="text-danger"> Topic is required  </span> : ""
            }

            {props.update == 1 ? <Row>

              <Col className="my-3" >
                <Button className='btn btn-block' variant="outline-success" onClick={e => props.reSchedule(data)} size="lg" >
                  Update Meeting
                </Button>
              </Col>

            </Row> : <Row>
              <Col className="my-3" id="loading" >

                <Button className='btn btn-block'
                  variant="outline-success"
                  onClick={onSubmit} size="lg"
                  id="createButton"
                >
                  Create Meeting
                </Button>
              </Col>

            </Row>}

          </Container>

        </Form.Group>
      </Form>

      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </Modal>


  );
}

function CenterModel(props) {

  const [modalShow, setModalShow] = React.useState(true);

  return (
    <React.Fragment>


      <MyVerticallyCenteredModal
        IR_STATUS={props.IR_STATUS}
        update={props.update}
        reSchedule={props.onUpdate}
        show={modalShow}
        onHide={() => setModalShow(false)}
        createMeeting={props.onClick}
      />
    </React.Fragment>
  );
}



export default CenterModel
